import { render, staticRenderFns } from "./FaceScan.vue?vue&type=template&id=7e256935"
import script from "./FaceScan.vue?vue&type=script&lang=js"
export * from "./FaceScan.vue?vue&type=script&lang=js"
import style0 from "./FaceScan.vue?vue&type=style&index=0&id=7e256935&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports